var map = {
	"./en_CA": [
		552925,
		914
	],
	"./en_CA.json": [
		552925,
		914
	],
	"./fr_CA": [
		543572,
		193
	],
	"./fr_CA.json": [
		543572,
		193
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 799532;
module.exports = webpackAsyncContext;